<app-admin-page-shell
  titleKey="app.admin.contentPage.title"
  subtitleKey="app.admin.contentPage.subtitle"
>
  @if (hasCourses()) {
    <div adminPageActions>
      <app-cta-button variant="light" size="small" (clicked)="openNewCourseModal()">
        <img cta-prefix src="/public/svgs/plus-rounded.svg" alt="" />
        <span cta-label>{{ 'app.admin.contentPage.newCourse' | translate }}</span>
      </app-cta-button>
    </div>
  }

    @if (isLoading()) {
      <div class="loading-state">
        <mat-spinner diameter="40"></mat-spinner>
        <p>{{ 'app.admin.contentPage.loading' | translate }}</p>
      </div>
    } @else if (hasCourses()) {
      <ng-template #courseRow let-course>
        <td class="col-hero col-center course-image-cell">
          <div
            class="course-image-wrap"
            [attr.aria-label]="
              course.status === 'ARCHIVED'
                ? ('app.admin.contentPage.archivedCourseImage' | translate)
                : null
            "
          >
            @if (hasCourseHeroImage(course)) {
              <img
                [src]="course.courseImageUrl"
                [alt]="course.courseName"
                class="course-image-avatar"
                (error)="onCourseImageError(course.id)"
              />
            } @else if (showCourseHeroSpinner(course)) {
              <div
                class="course-hero-spinner-wrap"
                role="status"
                [attr.aria-label]="'app.admin.contentPage.loading' | translate"
              >
                <mat-spinner diameter="36" class="course-hero-spinner" />
              </div>
            } @else {
              <span class="course-image-placeholder">—</span>
            }
            @if (course.status === 'ARCHIVED') {
              <span class="course-archived-badge">{{
                'app.admin.contentPage.status.ARCHIVED' | translate
              }}</span>
            }
          </div>
        </td>
        <td class="course-name-cell col-center">{{ course.courseName }}</td>
        <td class="category-cell col-center">{{ course.category }}</td>
        <td class="col-center">{{ statusLabel(course.status) }}</td>
        <td class="col-center">
          {{ course.estimatedDuration }}
          {{ 'app.admin.contentPage.minutesSuffix' | translate }}
        </td>
        <td class="col-center">{{ sourceLabel(course.source) }}</td>
        <td class="col-center col-actions">
          @if (course.status !== 'ARCHIVED') {
            <app-cta-button
              variant="light"
              size="small"
              (clicked)="openCourseInEditor(course)"
            >
              <span cta-label>{{ 'app.admin.contentPage.openCourse' | translate }}</span>
            </app-cta-button>
          }
        </td>
      </ng-template>
      <app-admin-data-table
        [columns]="columns"
        [rows]="courses()"
        [rowTemplate]="courseRow"
        [trackByProp]="trackCourse"
        variant="desktop-only"
      />

      <div class="courses-cards courses-cards--mobile">
        @for (course of courses(); track course.id) {
          <app-course-card
            [course]="course"
            [statusLabel]="statusLabel"
            [sourceLabel]="sourceLabel"
            [hasHeroImage]="hasCourseHeroImage"
            [showHeroSpinner]="showCourseHeroSpinner"
            (openCourse)="openCourseInEditor($event)"
            (imageError)="onCourseImageError($event)"
          />
        }
      </div>
    } @else {
      <div class="empty-state">
        <p>{{ 'app.admin.contentPage.empty' | translate }}</p>
        <app-cta-button variant="light" size="small" (clicked)="openNewCourseModal()">
          <img cta-prefix src="/public/svgs/plus-rounded.svg" alt="" />
          <span cta-label>{{ 'app.admin.contentPage.newCourse' | translate }}</span>
        </app-cta-button>
      </div>
    }

  <app-modal
    [isOpen]="isCourseModalOpen()"
    [config]="{
      title: 'app.components.courseModal.createTitle',
      minHeight: '50rem',
      minWidth: '60rem',
      maxWidth: '60rem',
    }"
    (closed)="onCourseModalClosed()"
  >
    <app-course-creator
      [selectedCourse]="selectedCourseForCreator()"
      [initialStep]="courseCreatorModalStep()"
      [steps]="courseCreatorSteps"
      layoutVariant="admin"
    />
  </app-modal>

  <!-- <section class="content-page__generator" aria-labelledby="content-new-heading">
    <h2 id="content-new-heading" class="content-page__generator-title">
      {{ 'app.admin.contentPage.generatorHeading' | translate }}
    </h2>
    <app-content-generator /> -->
  <!-- </section> -->
</app-admin-page-shell>
